import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Button } from "../../../../components/Button";
import { Form, FormField, useForm } from "../../../../components/Form";
import { TextInput } from "../../../../components/Inputs";
import { useCurrentBreakpoint } from "../../../../hooks/useCurrentBreakpoint";
import CloseIcon from "../../../../icons/close.svg";
import SearchIcon from "../../../../icons/search.svg";
import { useTranslations } from "../../../../providers/useTranslations";
import { navigateTo } from "../../../../utils/navigateTo";
import styles from "./SearchForm.module.scss";
const buttonSizes = {
    xs: "small",
    sm: "medium",
    md: "medium",
    lg: "medium",
};
export const SearchForm = ({ translations, resultsPage, initialSearchValue, isInputAutoFocus = true, minSearchTextLength = 3, onSearchSubmit, navigationFn, }) => {
    const { __ } = useTranslations();
    const { mainBreakpoint } = useCurrentBreakpoint();
    const form = useForm({ defaultValues: { searchValue: "" } });
    const [isPendingLocationChange, setPendingLocationChange] = useState(false);
    const { reset, watch, formState: { isDirty, isValid }, } = form;
    const searchValue = watch("searchValue");
    const handleSubmit = () => {
        if (resultsPage) {
            setPendingLocationChange(true);
            return navigateTo({ pathName: resultsPage, params: { q: searchValue }, navigationFn });
        }
        onSearchSubmit?.(searchValue);
    };
    const clearForm = () => {
        reset({
            searchValue: "",
        });
    };
    useEffect(() => {
        if (initialSearchValue) {
            form.setValue("searchValue", initialSearchValue, { shouldDirty: true, shouldValidate: true });
        }
    }, [form, initialSearchValue]);
    return (_jsx("div", { className: styles.searchFormContainer, "data-testid": "searchFormContainer", children: _jsx(Form, { form: form, onSubmit: handleSubmit, dataTestId: "searchForm", children: _jsxs("div", { className: styles.searchFormWrapper, children: [_jsx("div", { className: styles.searchInputWrapper, children: _jsx(FormField, { name: "searchValue", className: styles.searchInputFormField, render: ({ field }) => (_jsx(TextInput, { ...field, iconLeft: SearchIcon, iconRight: searchValue && CloseIcon, onRightIconClick: clearForm, placeholder: translations?.placeholder ?? __("search.input_placeholder"), dataTestId: "searchInput", autoFocus: isInputAutoFocus })), validation: {
                                minLength: minSearchTextLength,
                            } }) }), _jsx(Button, { color: "primary", type: "submit", variant: "cta", isPending: isPendingLocationChange, className: styles.searchSubmit, "data-testid": "searchSubmit", disabled: !isDirty || !isValid, size: buttonSizes[mainBreakpoint], children: translations?.buttonLabel ?? __("search.button_label") })] }) }) }));
};
//# sourceMappingURL=SearchForm.js.map